import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "wait",
  "name": "Wait",
  "category": "utilities",
  "description": "Pause workflow execution for a specified time",
  "icon": "Timer",
  "color": "gray",
  "version": "1.1.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Wait",
    "color": "#6b7280"
  },
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "wait",
    "delay",
    "sleep",
    "pause",
    "timer"
  ]
};

export default definition;
